export default __webpack_public_path__ + "static/media/jetball.80227ea4.png";